import React from 'react'

import { ProductCard as ProductCardDS } from '@src/ds/blocks/product-card'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductCardLegacy, type ProductCardProps } from './product-card.component-legacy'

export type { ProductCardProps }

export function ProductCard(props: ProductCardProps) {
  if (shouldUseDesignSystem()) {
    return <ProductCardDS {...props} />
  }
  return <ProductCardLegacy {...props} />
}
